import { FC } from 'react'
import Svg, { G, Path, SvgProps } from 'react-native-svg'

const MenuIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg viewBox="0 0 32 32" width={32} height={32} fill="none" {...props}>
            <G>
                <Path
                    fill={color}
                    d="M7.723 24.3a.95.95 0 0 1-.275-.7q0-.425.275-.7l9.55-9.55q-.45-1.05-.125-2.375.326-1.325 1.425-2.375 1.326-1.325 2.95-1.55 1.626-.225 2.65.8 1.026 1.025.8 2.65-.224 1.625-1.55 2.95-1.05 1.1-2.375 1.425t-2.375-.125L17.423 16l6.9 6.9a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-6.9-6.85-6.9 6.85q-.3.3-.7.3a.96.96 0 0 1-.7-.3m3.65-7.85-3-3q-1.125-1.125-1.312-2.625A4.47 4.47 0 0 1 7.623 8a.93.93 0 0 1 .75-.475q.5-.05.875.35l5.325 5.375z"
                />
            </G>
        </Svg>
    )
}

export default MenuIcon
